var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.333252C5.20065 0.333252 3.53398 1.06659 2.26732 2.33325C1.00065 3.59992 0.333984 5.33325 0.333984 7.13325C0.333984 10.7333 3.26732 13.6666 6.86732 13.6666H7.00065C10.7333 13.5999 13.6673 10.5999 13.6673 6.86659C13.6673 3.26659 10.7333 0.333252 7.13398 0.333252H7.00065ZM6.46732 4.05332C6.46732 3.71999 6.73398 3.51998 7.00065 3.51998C7.33398 3.51998 7.53398 3.78665 7.53398 4.05332V7.38665C7.53398 7.71998 7.26732 7.91998 7.00065 7.91998C6.66732 7.91998 6.46732 7.71998 6.46732 7.38665V4.05332ZM7.00052 10.4867C6.52187 10.4867 6.13385 10.0987 6.13385 9.62005C6.13385 9.1414 6.52187 8.75338 7.00052 8.75338C7.47916 8.75338 7.86718 9.1414 7.86718 9.62005C7.86718 10.0987 7.47916 10.4867 7.00052 10.4867Z",
    fill: "#E25353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0a694cded36b38bc5db87e4c5502c4f1.svg";
export { ForwardRef as ReactComponent };